import React, { Component } from 'react';
import { Form, Field, FieldArray } from 'redux-form';
import { Grid, Row, Col, Button, Popover } from 'react-bootstrap';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ButtonStandardPrimary from 'components/atoms/buttons/standard/Primary';
import FormHeading from 'components/atoms/form/FormHeading';
import { AddNewButton, RemoveButton, FieldWrapper } from 'components/atoms/buttons/ListOperations';
import TextInputAdmin from 'components/atoms/inputs/TextInputAdmin';
import StyledLabel from 'components/atoms/inputs/Label';
import InputTip from 'components/atoms/form/InputTip';
import LayerAliasesSubHeading from 'components/molecules/LayerAliasesSubHeading';
import ChannelVisibilitySubHeading from 'components/molecules/ChannelVisibilitySubHeading';
import LayerTypeCombo from 'components/molecules/LayerTypeCombo';
import DefaultChannelsBlock from 'components/molecules/DefaultChannelsBlock';
import LabelWithHelpOverlay from 'components/molecules/LabelWithHelpOverlay';
import PaddedLabel from 'components/molecules/PaddedLabel';

const CancelButton = styled(Button)`
    margin: 0 10px;
    padding: 0px 25px;
    font-size: 16px;
    height: 48px;
`;

const rowStyle = {
    display: 'flex'
};


const renderBrandAliases = ({ fields, meta: { error, submitFailed } }) => {
    if (fields.length === 0) {
        fields.push();
    }

    return (
        <div>
            {fields.map((brandAlias, index) => (
                <Row style={rowStyle} key={index}>
                    {submitFailed && error && <span>{error}</span>}

                    <Col xs={9} md={3}>
                        {/* Add padding to first row to match padding for the Layer Type input with help text */}
                        { index === 0 ? <PaddedLabel>Name</PaddedLabel> : <StyledLabel>Name</StyledLabel>}
                        <Field component={TextInputAdmin} required={false} label="Name" type="text" name={`${brandAlias}.name`}>
                        </Field>
                    </Col>

                    <Col xs={6} md={2}>
                        { index === 0 ?
                            <LabelWithHelpOverlay overlay={
                                <Popover id="layer-types" title="What are Layer Types?">
                                    <div>
                                        <p>
                                            The <b>layer type</b> (i.e., parent or child) determines if the dashboard
                                            has child dashboards that it must aggregate, and this affects what displays
                                            in the dashboard. There are two types:
                                        </p>
                                        <p>
                                            <b>Parent (Layer 2)</b> - Use this type for dashboards that are parents of
                                            other dashboards (i.e., they have child dashboards). These dashboards
                                            typically don’t have any work orders assigned to them; they just aggregate
                                            the data from child dashboards.
                                        </p>
                                        <p>
                                            <b>Child (Layer 3)</b> - Use this type for dashboards that do not have any
                                            child dashboards. These dashboards will have work orders assigned.
                                        </p>
                                    </div>
                                </Popover>
                            }>
                                Layer Type
                            </LabelWithHelpOverlay>
                            :
                            <StyledLabel>Layer Type</StyledLabel>}
                        <FieldWrapper>
                            <Field component={LayerTypeCombo}
                                name={`${brandAlias}.layer`}>
                            </Field>
                            {fields.length > 1 &&
                                <RemoveButton className='icon-close' type="button" title="Remove Layer" onClick={() => fields.remove(index)} />
                            }
                        </FieldWrapper>
                    </Col>
                </Row>
            ))}
            <AddNewButton type="button" title="Add Layer"
                onClick={() => fields.push({})}>Add Layer
            </AddNewButton>
        </div>
    );
};

class EditBrandForm extends Component {
    renderHeading() {
        if (this.props.brand) {
            return (
                <FormHeading>Edit Brand:&nbsp;
                    {this.props.brand &&
                        <span>
                            {this.props.brand.name}
                        </span>
                    }
                </FormHeading>
            );
        }

        return (
            <FormHeading>Create New Brand</FormHeading>
        );
    }

    render() {
        return (
            <Form onSubmit={this.props.handleSubmit()} id="editBrandForm">
                <Grid fluid>
                    {this.renderHeading()}
                    <Row>
                        <Col md={6}>
                            <StyledLabel required>Name</StyledLabel><br />
                            <Field component={TextInputAdmin} name="name" label="Name"
                                type="text" required={true} />
                        </Col>
                    </Row>

                    <LayerAliasesSubHeading />
                    <FieldArray name="BrandAliases" component={renderBrandAliases} />
                    <br />
                    <ChannelVisibilitySubHeading />
                    <DefaultChannelsBlock />

                    <Row>
                        <Col md={6}>
                            <StyledLabel>Marketing Enrollment Site</StyledLabel>
                            <Field component={TextInputAdmin} name="enrollmentSite" label="Enrollment Site"
                                type="text" required={false} />
                            <InputTip>'http://' or 'https://' required</InputTip>
                        </Col>
                    </Row>

                    <br />

                    <ButtonStandardPrimary type="submit">Submit</ButtonStandardPrimary>
                    <CancelButton onClick={this.props.cancel} type="reset" bsStyle='link'>Cancel</CancelButton>
                </Grid>
            </Form>
        );
    }
}

EditBrandForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    brand: PropTypes.object,
    cancel: PropTypes.func.isRequired,
};

export default EditBrandForm;



// WEBPACK FOOTER //
// ./src/components/organisms/forms/EditBrand.js